import { SET_PASSPORT, CLEAR_PASSPORT } from "./types";

const initialState = {};

export const passportReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case SET_PASSPORT:
      return {...payload} ;

    case CLEAR_PASSPORT:
      return "";

    default:
      return state;
  }
};
